import { createContext, PropsWithChildren, useContext } from 'react';

type AppCoreStateType = {
    RunningAppType: AppType;
    Environment: EnvironmentType;
};

export enum AppType {
    Support = 1,
    Dashboard = 2
}

export enum EnvironmentType {
    SB = 1,
    QA = 2,
    Production = 3
}

const initialState: AppCoreStateType = {
    RunningAppType: process.env.REACT_APP_TYPE === 'DASHBOARD' ? AppType.Dashboard : AppType.Support,
    Environment: process.env.REACT_APP_ENVIRONMENT === 'Sandbox' ?
        EnvironmentType.SB :
        process.env.REACT_APP_ENVIRONMENT === 'QA' ?
            EnvironmentType.QA :
            EnvironmentType.Production,
};

const AppCoreStateContext = createContext<AppCoreStateType>(initialState);

export const AppCoreProvider: React.FC<PropsWithChildren> = (props) => {
    return (
        <AppCoreStateContext.Provider value={initialState}>
            {props.children}
        </AppCoreStateContext.Provider>
    );
};

export const useAppCoreState = () => {
    const context = useContext(AppCoreStateContext);
    if (!context) {
        throw new Error('No AppCore Context');
    }

    return context;
};